import { crypto_currencies } from './Currencies'

const sec_to_miliseconds = 1000
const min_to_miliseconds = 60 * sec_to_miliseconds
const hour_to_miliseconds = 60 * min_to_miliseconds
const day_to_miliseconds = 24 * hour_to_miliseconds

const personDocumentTypes = ['cpf', 'curp', 'cc', 'ce', 'rfc_pf', 'passport']
const companyDocumentTypes = ['cnpj', 'rfc', 'nit', 'tax_id']

let centsToMoney = (cents_value) => {
  const splited_value = String(cents_value / 100.0).split('.')
  const int_part      = splited_value[0]
  let dec_part        = splited_value[1]
  dec_part            = (typeof dec_part === 'undefined' ? '00' : (dec_part.length === 1 ? dec_part + '0' : dec_part))
  return `${int_part}.${dec_part}`
}

let dbDateToHuman = (db_date) => {
  let d = db_date || ''
  return d.split('-').reverse().join('/')
}

let isValidDate = (s) => {
  const [year, month, day] = String(s).split('-')
  let d = new Date(year + '/' + month + '/' + day);
  return !!(d && (d.getMonth() + 1) == month && d.getDate() == Number(day));
}

let humanDateToDb = (human_date) => {
  let d = human_date || ''
  return human_date.split('/').reverse().join('-')
}

let toLocal = (utc_datetime) => {
  const timezoneOffset = utc_datetime.getTimezoneOffset() * 60000
  return new Date( utc_datetime.getTime() - timezoneOffset)
}

let toUTC = (utc_datetime) => {
  const timezoneOffset = utc_datetime.getTimezoneOffset() * 60000
  return new Date( utc_datetime.getTime() + timezoneOffset)
}

let dbDateTimeToHuman = (db_date, lang = 'pt-BR') => {
  if (!db_date) return '';

  const utc = new Date(db_date);
  const local = toLocal(utc);
  const date = local.toLocaleDateString(lang);
  const time = local.toLocaleTimeString(lang);
  return `${date} ${time}`;
};

const dbDateTimeToHumanDate = (dbDate, lang = 'pt-BR') => {
  if (!dbDate) return '';

  let date = new Date(dbDate);

  // Try to convert formats not ISO (like "13/06/2024 15:20:44")
  if (isNaN(date)) {
    const match = dbDate.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}):(\d{2}))?$/);
    if (match) {
      const [, day, month, year, hour = '00', minute = '00', second = '00'] = match;
      const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      date = new Date(isoString);
    }
  }

  if (isNaN(date)) return 'Data inválida';

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${day}/${month}/${year}`;
};

let dateBusinessTime = (utc_db_date_time, now_miliseconds, current_date) => {
  let utc = new Date(utc_db_date_time)
  let utc_miliseconds = utc.getTime()

  const w = (new Date(current_date + 'T11:00:00.000000')).getDay()
  if ((w == 0) || (w == 6)) { return 0 }

  let business_start = (new Date(current_date + 'T11:00:00.000000')).getTime()
  let business_end = (new Date(current_date + 'T21:00:00.000000')).getTime()
  let base_start = business_start
  let base_end = business_end

  if (now_miliseconds <= business_start) { return 0 }
  if (utc_miliseconds > business_start) { base_start = utc_miliseconds }
  if (now_miliseconds < business_end) { base_end = now_miliseconds }
  if (utc_miliseconds > business_end) { return 0 }

  return base_end - base_start
}

let timeMilisecondsToDateObj = (miliseconds) => {
  const diff_days = Math.trunc(miliseconds / day_to_miliseconds)
  const diff_days_miliseconds = diff_days * day_to_miliseconds

  const diff_hours = Math.trunc((miliseconds - diff_days_miliseconds) / hour_to_miliseconds)
  const diff_hours_miliseconds = diff_hours * hour_to_miliseconds

  const diff_minutes = Math.trunc((miliseconds - diff_days_miliseconds - diff_hours_miliseconds) / min_to_miliseconds)
  const diff_minutes_miliseconds = diff_minutes * min_to_miliseconds

  const diff_seconds = Math.trunc((miliseconds - diff_days_miliseconds - diff_hours_miliseconds - diff_minutes_miliseconds) / sec_to_miliseconds)

  return { days: diff_days, hours: diff_hours, minutes: diff_minutes, seconds: diff_seconds, difference_miliseconds: miliseconds }
}

let b64ToUrl = (b64Data, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return URL.createObjectURL(new Blob(byteArrays, {type: contentType}));
}

let sinceDbDateTimeToObj = (db_date) => {
  const utc = new Date(db_date)
  const now_miliseconds = toUTC(new Date(Date.now())).getTime()

  return timeMilisecondsToDateObj(now_miliseconds - utc.getTime())
}

let sinceDbDateTimeToBusinessObj = (db_date) => {
  const utc = new Date(db_date)
  const now_miliseconds = toUTC(new Date(Date.now())).getTime()

  let timeToDate = (date) => {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')

    return `${y}-${m}-${d}`
  }

  let current_date = timeToDate(new Date(now_miliseconds))
  let initial_date = timeToDate(utc)
  let offset = 0
  let result_miliseconds = 0

  while (current_date >= initial_date ) {
    result_miliseconds = result_miliseconds + dateBusinessTime(utc, now_miliseconds, current_date)
    offset = offset + (1 * day_to_miliseconds)
    current_date = timeToDate(new Date(now_miliseconds - offset))
  }

  return timeMilisecondsToDateObj(result_miliseconds)
}

let timeObjToHuman = (time_object, lang) => {
  if (typeof lang == 'undefined') { lang = 'pt' }
  const all_labels = { pt: ['segundos', 'minutos', 'horas', 'dias'], en: ['seconds', 'minutes', 'hours', 'days'] }
  const some = (lang == 'en' ? 'some' : 'alguns')

  const labels = all_labels[lang]
  let values   = [time_object.seconds, time_object.minutes, time_object.hours, time_object.days]

  if (time_object.seconds < 0) {
    values[0] = some
  }

  const last_is_zero = function(list) { return (list[list.length - 1] === 0) }
  while (last_is_zero(values) && (values.length > 1)) { values.pop() }

  var result = ''
  values.map(function (value, index) {
    result = `${value} ${labels[index]} ${result}`
  })
  return result
}

let sinceDbDateTimeToHuman = (db_date, lang) => {
  const diff_obj = sinceDbDateTimeToObj(db_date)
  return timeObjToHuman(diff_obj, lang)
}

let sinceDbBusinessDateTimeToHuman = (db_date, lang) => {
  const diff_obj = sinceDbDateTimeToBusinessObj(db_date)
  return timeObjToHuman(diff_obj, lang)
}

let currencyToLocal = (number, currency) => {
  if (crypto_currencies.includes(currency)) {
    return formatCryptoCurrency(number, currency, 'pt-BR')
  } else {
    return Number(number).toLocaleString('pt-BR', { style: 'currency', currency: currency })
  }
}

let localeCurrency = (number, currency, locale = 'en-US') => {
  if (crypto_currencies.includes(currency)) {
    return formatCryptoCurrency(number, currency, locale)
  } else {
    return Number(number).toLocaleString(locale, { style: 'currency', currency: currency })
  }
}

let formatCryptoCurrency = (number, currency, locale) => {
  const formattedNumber = new Intl.NumberFormat(locale, { style: "decimal" }).format(number)

  return `${currency}$ ${formattedNumber}`
}

let mask = (format, value) => {
  switch (format) {
    case 'cpf':
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4")
    case 'cnpj':
      return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5")
    case 'cc':
      return value.replace(/(\d{1})(\d{3})(\d{3})(\d{3})/g,"\$1.\$2.\$3.\$4")
    case 'nit':
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{1})/g,"\$1.\$2.\$3-\$4")
    case 'rut':
      return value.replace(/(\d{2})(\d{3})(\d{3})(\w{1})/g,"\$1.\$2.\$3-\$4")
    default:
      return value
  }
}

let shortAccountName = (account) => {
  let bank_name = account.bank.name
  let branch = account.routing_number
  let account_number = account.account_number
  let nickname = account.nickname && (account.nickname + ' - ') || ''
  if (branch == '' || branch === null) { branch = account.aba }
  if (branch == '' || branch === null) { branch = account.branch_number }
  if (branch == '' || branch === null) { branch = account.currency }
  if (account_number == '' || account_number === null) { account_number = account.iban }
  return `${nickname}${bank_name} - ${branch} - ${account_number}`
}

let longAccountNameForInternalWithoutPrefix = (account) => {
  if (!account) return ''

  const branchCountry = account.branch_country ? `(${account.branch_country})` : ''

  if (account.flow_type != null) {
    return `${account.currency} (${account.flow_type.toUpperCase().split('_').join('-')}/${account.nickname != null ? account.nickname: account.id.split('-')[0]}) ${branchCountry}`
  }

  return `${account.currency} (${account.nickname != null ? account.nickname: account.id.split('-')[0]}) ${branchCountry}`
}

let longAccountNameForInternal = (account, i18n = null) => {
  if (!account) return ''

  const prefix = !!i18n ? i18n('Conta interna') : 'Conta interna'

  if (account.flow_type != null) {
    return `${prefix} ${longAccountNameForInternalWithoutPrefix(account)}`
  }

  return `${prefix} ${longAccountNameForInternalWithoutPrefix(account)}`
}

let longAccountName = (account, i18n = null) => {
  if (!account) return ''
  if (account.internal === true) return longAccountNameForInternal(account, i18n)

  let bank_name = account.bank && `${account.bank.name} ` || ''
  let bank_code = account.bank && account.bank.swift
  if (!bank_code) {
    bank_code = account.bank && (account.bank.code || account.bank.ispb)
  }
  if (bank_code) {
    bank_code = `(${bank_code}) `
  } else {
    bank_code = ''
  }
  let aba = account.aba ? `ABA ${account.aba} ` : ''
  let routing = account.routing_number ? `RN ${account.routing_number} ` : ''
  let iban = account.iban ? `IBAN ${account.iban} ` : ''
  let branch_number = account.branch_number ? `Ag ${account.branch_number} ` : ''
  let account_number = account.account_number ? `${abbreviationForAccountType(account.account_type)} ${account.account_number} ` : ''
  let nickname = account.nickname ? `(${account.nickname})` : ''


  if (account.pix_info && account.pix_info.key && account_number === '') {
    bank_code = account.pix_info.key
  }

  let r = `${bank_name}${bank_code}${routing}${aba}${iban}${branch_number}${account_number}${nickname}`
  return r
}

let shortBankName = (account) => {
  let bank_name = account.bank.name
  let code = account.bank.code
  if (code == '' || code === null) { code = account.bank.swift }
  return `${bank_name} ${code}`
}

let isArray = (o) => {
  return typeof o == 'object' && Array.isArray(o)
}

let isObject = (o) => {
  return typeof o == 'object' && !Array.isArray(o)
}

// RUT is validated separately because it is a hybrid document type
let isPerson = (record) => {
  return personDocumentTypes.includes(record.document_type.toLowerCase())
  || (record.document_type.toLowerCase() == 'rut' && record.natural_person)
}

let isCompany = (record) => {
  return companyDocumentTypes.includes(record.document_type.toLowerCase())
  || (record.document_type.toLowerCase() == 'rut' && !record.natural_person)
}

let translateErrors = (param, lang) => {
  if (isObject(param)) {
    let errors = {...param}
    for (let field in errors) {
      errors[field] = translateErrors(errors[field], lang)
    }
    return errors
  } else if (isArray(param)) {
    return param.map((error_msg)=>{
      return translateErrorMessage(error_msg, lang)
    }).join(', ')
  } else {
    return translateErrorMessage(param, lang)
  }
}

let translateErrorMessage = (message, lang) => {
  if (lang === 'en') { return message }

  let translations = {
    "can't be blank": 'obrigatório',
    "can't be a future date": 'não pode ser uma data futura',
    'invalid': 'inválido',
    'is invalid': 'inválido',
    'has already been taken': 'já registrado',
    'Day already registered': 'Este dia já foi cadastrado',
    'mismatches with code': 'ispb e código não correspondem',
    'mismatches with ispb': 'ispb e código não correspondem',
    'decimals are not accepted for this currency': 'não são aceitas casas decimais para esta moeda',
    'Document number already registered': 'Documento já registrado',
    'Subject registration is locked.': 'Pessoa ou empresa bloqueada para transacionar',
    'to_bank_account is not allowed for cash_in operations': 'Operação não permitida para a conta de destino',
    'to_bank_account is not allowed for cash_out operations': 'Operação não permitida para a conta de destino',
    'has invalid format. Three or four digits are expected': 'Formato inválido. São esperados três ou quatro dígitos',
    'has invalid format. Eight digits are expected like: 00000001': 'Inválido. Mínimo de dígitos para este campo: 8.'
  }

  return translations[message] || message
}

let addressFormated = (record) => {
  return [
    record.address_street,
    record.address_number,
    record.address_complement,
    record.address_city,
    record.address_state,
    record.fiscal_country,
    record.address_postal_code
  ].filter((info) => {
    return String(info).length > 0
  }).join(' ')
}

let exportToFile = (filename, contents, filetype = 'text/csv;charset=utf-8;') => {
  var blob = new Blob([contents], { type: filetype });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

let exportToCsv = (filename, rows, separator = ';') => {
  let processRow = function (row) {
    let finalVal = '';
    for (let j = 0; j < row.length; j++) {
      let innerValue = ((row[j] === null) || (row[j] === undefined)) ? '' : row[j].toString();
      if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
      };
      let result = innerValue.replace(/"/g, '""');
      let pattern = new RegExp('("|' + separator + '|\n)', 'g')
      if (result.search(pattern) >= 0)
          result = '"' + result + '"';
      if (j > 0)
          finalVal += separator;
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  exportToFile(filename, csvFile, 'text/csv;charset=utf-8;')
}

let parseCommaField = (value) => {
  if (typeof value === 'string' && value.includes(',')) {
    return `"${value}"`
  }
  return value
}

let formatLargeNumberAsText = (value) => {
  if (value === null || value === undefined) return '';
  const strValue = value.toString();
  return strValue.length > 10 && `'${strValue}` || strValue;
}

let exportTransactionCsvForBank = (callback) => {
  callback([
    'TIPO_DOCUMENTO',
    'NUMERO_DOCUMENTO',
    'NOME',
    'PAIS',
    'CEP',
    'LOGRADOURO',
    'NUMERO',
    'COMPLEMENTO',
    'CIDADE',
    'ESTADO',
    'VALOR_MN',
    'VALOR_ME'
    ], (bank_transaction, rows) => {
    let mn_value
    let me_value
    if (bank_transaction.currency == 'BRL') {
      mn_value = bank_transaction.value
      me_value = bank_transaction.exchanged_value
    } else {
      me_value = bank_transaction.value
      mn_value = bank_transaction.exchanged_value
    }

    let s = bank_transaction.scheduled_bank_transaction && bank_transaction.scheduled_bank_transaction.subject
    if (s) {
      rows.push([
        s.document_type.toUpperCase(),
        parseCommaField(s.document_number),
        parseCommaField(s.social_name),
        s.fiscal_country,
        parseCommaField(s.address_postal_code),
        parseCommaField(s.address_street),
        parseCommaField(s.address_number),
        parseCommaField(s.address_complement),
        s.address_city,
        parseCommaField(s.address_state),
        mn_value,
        me_value
        ]
      )
    }
  }, ';')
}

let exportTransactionCsvForCustomer = (callback, wire) => {
  callback([
    'WIRE_ID',
    'WIRE_DATE',
    'TRANSACTION_DATE',
    'TRANSACTION_ID',
    'PERSON_ID',
    'SOCIAL_NAME',
    'EMAIL',
    'BRL_VALUE',
    'EXCHANGED_VALUE'
  ], (bank_transaction, rows) => {

    let wire_id = 'unregistered'
    let wire_date = ''

    if (wire) {
      wire_id = wire.id
      wire_date = wire.inserted_at
    }

    let mn_value
    let me_value

    if (bank_transaction.currency == 'BRL') {
      mn_value = bank_transaction.value
      me_value = bank_transaction.exchanged_value
    } else {
      me_value = bank_transaction.value
      mn_value = bank_transaction.exchanged_value
    }

    let s = bank_transaction.scheduled_bank_transaction.subject
    if (s) {
      rows.push([
        wire_id,
        wire_date ? dbDateTimeToHuman(wire_date) : '',
        bank_transaction.movement_date,
        bank_transaction.scheduled_bank_transaction.id,
        s.id,
        parseCommaField(s.social_name),
        parseCommaField(s.email),
        mn_value,
        me_value
      ])
    }
  }, ',')
}

let maskCNPJ = (cnpj) => {
	cnpj=cnpj.replace(/\D/g,"")
	cnpj=cnpj.replace(/^(\d{2})(\d)/,"$1.$2")
	cnpj=cnpj.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
	cnpj=cnpj.replace(/\.(\d{3})(\d)/,".$1/$2")
	cnpj=cnpj.replace(/(\d{4})(\d)/,"$1-$2")
	return cnpj
}

let maskCPF = (cpf) => {
	cpf=cpf.replace(/\D/g,"")
	cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
	cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
	cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
	return cpf
}

let currentDate = () => {
  let today = new Date()
  let dd   = String(today.getDate()).padStart(2, '0')
  let mm   = String(today.getMonth()+1).padStart(2, '0')
  let yyyy = String(today.getFullYear())

  return yyyy + '-' + mm + '-' + dd
}

let currentDateTime = () => {
  let today = new Date()
  let dd   = String(today.getDate()).padStart(2, '0')
  let mm   = String(today.getMonth()+1).padStart(2, '0')
  let yyyy = String(today.getFullYear())

  let hh = String(today.getHours()).padStart(2, '0')
  let mi = String(today.getMinutes()).padStart(2, '0')
  let ss = String(today.getSeconds()).padStart(2, '0')

  return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + mi + ':' + ss + '.000000'
}

let filterDateFrom = (filterDate, monthly = true) => {
  if(filterDate === null) {
    return null
  }
  let filterDateSplitted = filterDate.split('-')
  let year = Number(filterDateSplitted[0])
  let month = Number(filterDateSplitted[1])
  if (monthly) {
    return new Date(year, month - 1, 1)
  }

  let day = Number(filterDateSplitted[2])
  return new Date(year, month - 1, day)
}

let filterDateTo = (filterDate, monthly = true) => {
  if(filterDate === null) {
    return null
  }
  let filterDateSplitted = filterDate.split('-')
  let year = Number(filterDateSplitted[0])
  let month = Number(filterDateSplitted[1])
  let toDate = null

  if (monthly) {
    if(month === 12) {
      toDate = new Date(year + 1, 0, 0)
    }
    else {
      toDate = new Date(year, month, 0)
    }
    toDate.setHours(23, 59, 59)
    return toDate
  }

  let day = Number(filterDateSplitted[2])
  toDate = new Date(year, month - 1, day)
  toDate.setHours(23, 59, 59)
  return toDate
}

let browserLanguage = function () {
  let ua = window.navigator.userAgent.toLowerCase()
  try {
    if (ua.indexOf('chrome') !== -1) {
      return (navigator.languages[0] || navigator.browserLanguage || navigator.language || navigator.userLanguage).substr(0, 2)
    } else {
      return (navigator.browserLanguage || navigator.language || navigator.userLanguage).substr(0, 2)
    }
  } catch (e) {
    return undefined
  }
}

let filterHeaders = (admin, headers, value) => {
  if (!admin) {
    headers.splice(headers.findIndex(el => el.value == value), 1)
  }
  return headers
}

const parseBranchCountry = (branch_country) => {
  switch (branch_country) {
    case '':
    case null:
    case 'BRA':
      return 'Brasil'

    case 'COL':
      return 'Colômbia'

    case 'MEX':
      return 'México'

    case 'CHL':
      return 'Chile'

    default:
      return branch_country;
  }
}

const getBranchCountry = (currency) => {
  switch (currency) {
    case '':
    case null:
    case 'BRL':
      return 'BRA'

    case 'MXN':
      return 'MEX'

    case 'COP':
      return 'COL'

    case 'CLP':
      return 'CHL'

    default:
      return null;
  }
}

const maskForDocumentType = (document_type) => {
  switch (document_type) {
    case 'cpf':
      return '###.###.###-##'
    case 'cnpj':
      return '##.###.###/####-##'
    case 'curp':
      return 'AAAA######NNNNNNNN'
    case 'rfc':
      return 'AAA-######-NNN'
    case 'cc':
      return '#.###.###.###'
    case 'ce':
      return '#########'
    case 'nit':
      return '###.###.###-#'
    case 'rut':
      return '##.###.###-N'
    default:
      return ''
  }
}

const abbreviationForAccountType = (account_type) => {
  switch (account_type) {
    case 'conta-corrente':
      return 'C.C.'
    case 'poupanca':
      return 'C.AHO'
    case 'salario':
      return 'C.S.'
    case 'conta pagamento':
      return 'C.PG'
    default:
      return 'CTA'
  }
}

let letShowEmptyCurpIfRequired = (record) => {
  if (record.document_type == 'rfc_pf') {
    record.__document_type__ = 'rfc_pf'
    record.__document_number__ = record.document_number
    record.document_type = 'curp'
    record.document_number = ''
  }
  return record;
}

let isRfcPfWithoutCurp = (record) => {
  return record.document_type == 'curp' && record.document_number.length == 0 && record.rfc_pf.length > 0
}

let normalizeUpdateRecordIfRequired = (record) => {
  if (record.__document_type__ == 'rfc_pf') {
    if (record.document_number.length == 0 && record.document_type == 'curp') {
      record.document_type = record.__document_type__
      record.document_number = record.__document_number__
      delete record.__document_type__
      delete record.__document_number__
    }
  }
  return record;
}

export default { personDocumentTypes, companyDocumentTypes, centsToMoney, dbDateToHuman, humanDateToDb, b64ToUrl, dbDateTimeToHuman, sinceDbDateTimeToHuman, sinceDbBusinessDateTimeToHuman, sinceDbDateTimeToObj, sinceDbDateTimeToBusinessObj, currencyToLocal, localeCurrency, mask, shortAccountName, shortBankName, longAccountName, longAccountNameForInternalWithoutPrefix, isValidDate, isPerson, isCompany, translateErrors, translateErrorMessage, addressFormated, exportToCsv, exportToFile, exportTransactionCsvForBank, exportTransactionCsvForCustomer, maskCNPJ, maskCPF, currentDate, browserLanguage, filterDateFrom, filterDateTo, currentDateTime, filterHeaders, parseBranchCountry, getBranchCountry, maskForDocumentType, letShowEmptyCurpIfRequired, isRfcPfWithoutCurp, normalizeUpdateRecordIfRequired, parseCommaField, formatLargeNumberAsText, dbDateTimeToHumanDate }



// WEBPACK FOOTER //
// ./src/shared/Utils.js